import { coreApiWithInterceptors } from '../../../services/axiosInterceptor';
import {
  APICLOSETGroupsDefaultParams,
  DeleteCLOSETGroupsCommentsParams,
  DeleteCLOSETGroupsManagersParams,
  GetCLOSETGroupInfoResponse,
  GetCLOSETGroupsBillingHistoryParams,
  GetCLOSETGroupsBillingHistoryResponse,
  GetCLOSETGroupsCommentsParams,
  GetCLOSETGroupsCommentsResponse,
  GetCLOSETGroupsListResponse,
  GetCLOSETGroupsManagersResponse,
  GetCLOSETGroupsMembersSummaryResponse,
  GetCLOSETGroupsParams,
  GetCLOSETGroupsSubscriptionHistoryParams,
  GetCLOSETGroupsSubscriptionHistoryResponse,
  GetCLOSETGroupsUsageResponse,
  PostCLOSETGroupsCommentsParams,
  PostCLOSETGroupsManagersParams,
  PostCLOSETGroupsManagersResponse,
  PutCLOSETGroupsCommentsParams,
} from '../../../types/api/groups/closet';
import qs from 'qs';
import { CLOSETPaymentCurrency } from 'types/groups';

const CLOSET_GROUPS_URL = '/closet/groups';

export const getClosetGroups = async (
  params: GetCLOSETGroupsParams,
): Promise<GetCLOSETGroupsListResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${CLOSET_GROUPS_URL}`, {
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });
  return data;
};

export const getClosetGroupsManagers = async (): Promise<GetCLOSETGroupsManagersResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${CLOSET_GROUPS_URL}/managers`, {
    headers: { maxAge: 31536000 },
  });
  return data;
};

export const getGroupInfo = async ({
  groupId,
}: {
  groupId: string;
}): Promise<GetCLOSETGroupInfoResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${CLOSET_GROUPS_URL}/${groupId}`);
  return data;
};

export const postClosetGroupsManagers = async (
  params: PostCLOSETGroupsManagersParams,
): Promise<PostCLOSETGroupsManagersResponse> => {
  const { data } = await coreApiWithInterceptors.post(`${CLOSET_GROUPS_URL}/managers`, params);
  return data;
};

export const deleteClosetGroupsManagers = async ({
  groupId,
  userId,
}: DeleteCLOSETGroupsManagersParams): Promise<void> => {
  return await coreApiWithInterceptors.delete(`${CLOSET_GROUPS_URL}/${groupId}/managers/${userId}`);
};

export const getClosetGroupsMembersSummary = async ({
  groupId,
}: APICLOSETGroupsDefaultParams): Promise<GetCLOSETGroupsMembersSummaryResponse> => {
  const { data } = await coreApiWithInterceptors.get(
    `${CLOSET_GROUPS_URL}/${groupId}/members/summary`,
  );
  return data;
};

export const getClosetGroupsUsage = async ({
  groupId,
}: APICLOSETGroupsDefaultParams): Promise<GetCLOSETGroupsUsageResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${CLOSET_GROUPS_URL}/${groupId}/usage`);
  return data;
};

export const getClosetGroupsSubscriptionHistory = async ({
  groupId,
  ...params
}: GetCLOSETGroupsSubscriptionHistoryParams): Promise<GetCLOSETGroupsSubscriptionHistoryResponse> => {
  const { data } = await coreApiWithInterceptors.get(
    `${CLOSET_GROUPS_URL}/${groupId}/subscriptions/histories`,
    { params },
  );
  return data;
};

export const getClosetGroupsBillingHistory = async ({
  groupId,
  ...params
}: GetCLOSETGroupsBillingHistoryParams): Promise<GetCLOSETGroupsBillingHistoryResponse> => {
  const { data } = await coreApiWithInterceptors.get(
    `${CLOSET_GROUPS_URL}/${groupId}/billings/histories`,
    { params },
  );
  return data;
};

export const getClosetGroupsComments = async ({
  groupId,
  ...params
}: GetCLOSETGroupsCommentsParams): Promise<GetCLOSETGroupsCommentsResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${CLOSET_GROUPS_URL}/${groupId}/comments`, {
    params,
  });
  return data;
};

export const postClosetGroupsComments = async ({
  groupId,
  description,
}: PostCLOSETGroupsCommentsParams) => {
  const { data } = await coreApiWithInterceptors.post(`${CLOSET_GROUPS_URL}/${groupId}/comments`, {
    description,
  });
  return data;
};

export const deleteClosetGroupsComments = async ({
  commentId,
  groupId,
}: DeleteCLOSETGroupsCommentsParams) => {
  const { data } = await coreApiWithInterceptors.delete(
    `${CLOSET_GROUPS_URL}/${groupId}/comments/${commentId}`,
  );
  return data;
};

export const putClosetGroupsComments = async ({
  commentId,
  groupId,
  description,
}: PutCLOSETGroupsCommentsParams) => {
  const { data } = await coreApiWithInterceptors.put(
    `${CLOSET_GROUPS_URL}/${groupId}/comments/${commentId}`,
    { description },
  );
  return data;
};

export const patchClosetGroupsCurrency = async ({
  groupId,
  currency,
}: {
  groupId: string;
  currency: CLOSETPaymentCurrency;
}) => {
  const { data } = await coreApiWithInterceptors.patch(`${CLOSET_GROUPS_URL}/${groupId}/currency`, {
    currency,
  });
  return data;
};
